/* SOAR lazy autoplay-in-view video. Loads the source only when the element
   nears the viewport, autoplays muted/looped (GIF-like), pauses when out of
   view. Keeps heavy media off the critical path so first paint is never blocked. */
(function () {
  function load(v) {
    if (v.dataset.loaded || !v.dataset.src) return;
    v.dataset.loaded = '1';
    var s = document.createElement('source');
    s.src = v.dataset.src;
    s.type = 'video/mp4';
    v.appendChild(s);
    v.load();
  }

  if (!('IntersectionObserver' in window)) {
    // Fallback: just load + play everything.
    document.querySelectorAll('[data-soar-lazyvideo]').forEach(function (v) {
      load(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        load(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px' });

  function init(root) {
    (root || document).querySelectorAll('[data-soar-lazyvideo]').forEach(function (v) {
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
